import documentosAPI, { documentoServiceDownload } from 'api/Associado/documentos';
import duvidasAPI from 'api/Associado/duvidas';
import eventoAPI, { AssembleiaResponse } from 'api/Associado/evento';
import convocadoAPI, { AssembleiasConvocado } from 'api/Associado/convocado';
import { ErrorAPI } from 'api/Associado/methods';
import { AxiosError, AxiosResponse } from 'axios';
import { Action, Dispatch } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { IReducer } from 'store/Reducer';
import { getPautaAssociadoWithOrderedOptions } from 'utils/AssembleiaUtils';
import trigger from 'utils/DownloadTrigger';
import { getAssembleiasAssociadoEndpoint, getAssembleiasAssociadoEventoEndpoint } from '../../library/Apis';
import ApiService from '../../services/ApiService';
import { toRequest } from '../../utils/RequestUtils';
import { AssembleiasAssociadoActionTypes, ASSEMBLEIAS_ASSOCIADO_ACTIONS_DELETE_CURRENT_EVENT, ASSEMBLEIAS_ASSOCIADO_ACTIONS_DOWNLOAD_FILE_SUCCESS, ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_ALL, ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_BY_CPF_CNPJ, ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_CONTAS, ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_DUVIDAS, ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_EVENT, ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_PAUTAS, ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_ALL, ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_BY_CPF_CNPJ, ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_CONTAS, ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_DUVIDAS, ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_EVENT, ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_PAUTAS, ASSEMBLEIAS_ASSOCIADO_ACTIONS_REFRESH, ASSEMBLEIAS_ASSOCIADO_ACTIONS_REGISTRA_VOTO, ASSEMBLEIAS_ASSOCIADO_ACTIONS_REQUEST_FILE, ASSEMBLEIAS_ASSOCIADO_LOADING_RESPOSTA_PAUTA, ASSEMBLEIAS_ASSOCIADO_LOAD_RESPOSTA_PAUTA, IAssembleiaAssociadoDeleteCurrentEvent, IAssembleiaAssociadoRefresh, ASSEMBLEIAS_ASSOCIADO_ACTIONS_REGISTRA_PRESENCA, ASSEMBLEIAS_ASSOCIADO_LOADING_DOCUMENTOS, ASSEMBLEIAS_ASSOCIADO_LOAD_DOCUMENTOS, ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_RESULTADO_VOTO_PAUTA, ASSEMBLEIAS_ASSOCIADO_ACTIONS_RESULTADO_VOTO_PAUTA, ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_DEMAIS_ASSEMBLEIAS, ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_DEMAIS_ASSEMBLEIAS, ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_TOTAL_CONVOCACOES, ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_TOTAL_CONVOCACOES } from './AssembleiasAssociadoActionTypes';
import { IAssembleiaAssociado, IAssembleiaAssociadoPauta, IAssembleiaAssociadoRespostaPauta, IAssembleiaContasAssociado } from './AssembleiasAssociadoReducer';
import { IWSAssembleia } from './WSAssembleiasReducer';
import { AssembleiaContaAssociado } from 'models/AssembleiaContaAssociado';
import { DocumentoResponse } from 'api/Associado/documentos';
import { IAssembleiaResultadosVotos } from './AssembleiasAssessorReducer';

export const assembleiasAssociadoActionsLoadTotalConvocacoes = (
  idAssembleia: number,
  callbackSuccess?: (totalConvocacoes: number) => void,
  callbackError?: (error: ErrorAPI) => void
) => {
  return async (dispatch: Dispatch<AssembleiasAssociadoActionTypes>) => {
    dispatch({
      type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_TOTAL_CONVOCACOES,
      payload: true,
    });
    const { fail, data } = await convocadoAPI.convocacoes(idAssembleia);
    if (fail) {
      callbackError && callbackError(fail);
    }
    if (data) {
      dispatch({
        type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_TOTAL_CONVOCACOES,
        payload: data,
      });
      callbackSuccess && callbackSuccess(data);
    }
    dispatch({
      type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_TOTAL_CONVOCACOES,
      payload: false,
    });
  };
};

export const assembleiaAssociadoActionsRefresh = (assembleia: IWSAssembleia):IAssembleiaAssociadoRefresh => {
  return {
    type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_REFRESH,
    payload: assembleia
  }
}

export const assembleiasAssociadoActionsRegistraVoto = (
  idItemPauta: number,
  callbackSuccess?: Function,
  callbackError?: (error: AxiosError) => void
) => {
  return (dispatch: Dispatch<AssembleiasAssociadoActionTypes>) => {
    new Promise((resolve: Function, reject: (error: AxiosError) => void) => {
      const data = {
        idItemPauta,
      };
      toRequest(
        ApiService.post,
        [`${getAssembleiasAssociadoEndpoint()}voto/`, data],
        'save'
      ).then(
        () => {
          dispatch({
            type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_REGISTRA_VOTO
          })
          resolve();
        },
        (error: AxiosError) => {
          reject(error);
        }
      );
    }).then(
      pautas => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      error => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const assembleiasAssociadoResultadosVotos = (idPauta: number, callbackSuccess?: (resultados: IAssembleiaResultadosVotos) => void, callbackError?: (error: AxiosError<ErrorAPI>) => void) => {
  return (dispatch: Dispatch<AssembleiasAssociadoActionTypes>) => {
    dispatch({
      type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_RESULTADO_VOTO_PAUTA,
      payload: true
    });
    new Promise((resolve: (resultados: IAssembleiaResultadosVotos) => void, reject: () => void) => {
      toRequest(
        ApiService.get,
        [`${getAssembleiasAssociadoEndpoint(1)}pauta/${idPauta}/resultado-votos`],'')
        .then(
          (resp: AxiosResponse) => {
            const resultados: IAssembleiaResultadosVotos = resp.data as IAssembleiaResultadosVotos;
            dispatch({
              type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_RESULTADO_VOTO_PAUTA,
              payload: resultados
            });
            resolve(resultados);
          },
          () => {
            dispatch({
              type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_RESULTADO_VOTO_PAUTA,
              payload: false
            });
            reject();
          }
        )
    }).then(
      (resultados: IAssembleiaResultadosVotos) => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resultados);
        }
      },
      () => {}
    )
  }
}

export const assembleiasAssociadoActionsLoadPautas = (
  assembleiaId: number,
  callbackSuccess?: (pautas: IAssembleiaAssociadoPauta[]) => void,
  callbackError?: (error: AxiosError<ErrorAPI>) => void
) => {
  return (dispatch: Dispatch<AssembleiasAssociadoActionTypes>) => {
    dispatch({
      type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_PAUTAS,
      payload: true,
    });
    new Promise(
      (
        resolve: (pautas: IAssembleiaAssociadoPauta[]) => void,
        reject: (error: AxiosError<ErrorAPI>) => void
      ) => {
        toRequest(
          ApiService.get,
          [
            `${getAssembleiasAssociadoEndpoint()}pauta/pautas-assembleia/${assembleiaId}`,
          ],
          'assembleiasAssociadoActionsLoadContas'
        ).then(
          resp => {
            const pautas: IAssembleiaAssociadoPauta[] = resp.data as IAssembleiaAssociadoPauta[];
            const data: IAssembleiaAssociadoPauta[] = pautas.map(
              (pauta: IAssembleiaAssociadoPauta): IAssembleiaAssociadoPauta => {
                return getPautaAssociadoWithOrderedOptions(pauta)
              }
            );
            dispatch({
              type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_PAUTAS,
              assembleiaId,
              payload: data,
            });
            dispatch({
              type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_PAUTAS,
              payload: false,
            });
            resolve(data);
          },
          (error: AxiosError<ErrorAPI>) => {
            dispatch({
              type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_PAUTAS,
              payload: false,
            });
            reject(error);
          }
        );
      }
    ).then(
      pautas => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(pautas);
        }
      },
      error => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

let contasLoading: {
  assembleiaId: number,
  cpfCnpj: string,
  loading: boolean
}[] = [];

const getContasLoadingIndex = (assembleiaId: number): number => {
  return contasLoading.map((conta): number => {
    return conta.assembleiaId
  }).indexOf(assembleiaId);
}

const contasIsLoading = (assembleiaId: number, cpfCnpj: string): boolean => {
  const foundIndex = getContasLoadingIndex(assembleiaId);
  const found = foundIndex > -1 ? contasLoading[foundIndex] : null;
  if (found) {
    return found.assembleiaId === assembleiaId && found.cpfCnpj === cpfCnpj && found.loading;
  }
  return false;
}

const setContasLoading = (assembleiaId: number, cpfCnpj: string, loading: boolean = true) => {
  const foundIndex = getContasLoadingIndex(assembleiaId);
  if (foundIndex > -1) {
    contasLoading[foundIndex] = {
      ...contasLoading[foundIndex],
      loading
    };
  } else {
    contasLoading.push({
      assembleiaId,
      cpfCnpj,
      loading
    })
  }
}

export const assembleiasAssociadoActionsLoadContas = (
  assembleiaId: number,
  cpfCnpj: string,
  callbackSuccess?: (contas: IAssembleiaContasAssociado) => void,
  callbackError?: (error: AxiosError<ErrorAPI>) => void
) => {
  return (dispatch: Dispatch<AssembleiasAssociadoActionTypes>) => {
    if (contasIsLoading(assembleiaId, cpfCnpj)) {
      return;
    }
    setContasLoading(assembleiaId, cpfCnpj, true);
    dispatch({
      type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_CONTAS,
      payload: true,
    });
    new Promise(
      (
        resolve: (contas: IAssembleiaContasAssociado) => void,
        reject: (error: AxiosError<ErrorAPI>) => void
      ) => {
        toRequest(
          ApiService.get,
          [
            `${getAssembleiasAssociadoEndpoint()}convocado/assembleia/${assembleiaId}`,
          ],
          'assembleiasAssociadoActionsLoadContas'
        ).then(
          resp => {
            const contas: AssembleiaContaAssociado[] = resp.data.map((dataItem: any): AssembleiaContaAssociado => {
              return {
                ...dataItem,
                nomeAssociado: dataItem.nomeAssociado || dataItem.nome || ''
              }
            }) as AssembleiaContaAssociado[];
            let idsConvocados: number[] = [];
            const data: IAssembleiaContasAssociado = {
              assembleiaId: assembleiaId,
              contas: contas.filter((conta: AssembleiaContaAssociado) => {
                if (idsConvocados.indexOf(conta.idConvocado) === -1) {
                  idsConvocados.push(conta.idConvocado);
                  return true;
                }
                return false;
              }),
            };
            dispatch({
              type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_CONTAS,
              payload: data,
            });
            dispatch({
              type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_CONTAS,
              payload: false,
            });
            setContasLoading(assembleiaId, cpfCnpj, false);
            resolve(data);
          },
          (error: AxiosError<ErrorAPI>) => {
            dispatch({
              type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_CONTAS,
              payload: false,
            });
            setContasLoading(assembleiaId, cpfCnpj, false);
            reject(error);
          }
        );
      }
    ).then(
      contas => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(contas);
        }
      },
      error => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const assembleiasAssociadoActionsRegistrarPresenca = (
  cpfCnpj: string,
  idsConvocados: number[],
  assembleiaId: number,
  callbackSuccess?: () => void,
  callbackError?: (error: AxiosError<ErrorAPI>) => void
) => {
  return (dispatch: Dispatch<AssembleiasAssociadoActionTypes>) => {
    new Promise<any>((resolve: Function, reject: (error: AxiosError<ErrorAPI>) => void) => {
      toRequest(
        ApiService.post,
        [
          `${getAssembleiasAssociadoEndpoint()}presenca/`,
          {
            convocacoes: idsConvocados,
            idAssembleia: assembleiaId,
          },
        ],
        'save'
      ).then(
        () => {
          dispatch({
            type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_REGISTRA_PRESENCA,
            payload: {
              cpfCnpj: cpfCnpj,
              idsConvocados: idsConvocados,
              assembleiaId: assembleiaId,
            }
          });
          resolve(undefined);
        },
        (error: AxiosError<ErrorAPI>) => {
          reject(error);
        }
      );
    }).then(
      () => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      error => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const assembleiasAssociadoActionsLoadAll = (
  callbackSuccess?: (all: IAssembleiaAssociado[]) => void,
  callbackError?: (error: AxiosError<ErrorAPI>) => void
) => {
  return (dispatch: Dispatch<AssembleiasAssociadoActionTypes>) => {
    dispatch({
      type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_ALL,
      payload: true,
    });
    new Promise(
      (
        resolve: (all: IAssembleiaAssociado[]) => void,
        reject: (error: AxiosError<ErrorAPI>) => void
      ) => {
        toRequest(
          ApiService.get,
          [`${getAssembleiasAssociadoEventoEndpoint()}assembleia`],
          'assembleiasAssociadoActionsLoadAll'
        ).then(
          resp => {
            const data: IAssembleiaAssociado[] = resp.data as IAssembleiaAssociado[];
            dispatch({
              type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_ALL,
              payload: data,
            });
            dispatch({
              type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_ALL,
              payload: false,
            });
            resolve(data);
          },
          (error: AxiosError<ErrorAPI>) => {
            dispatch({
              type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_ALL,
              payload: false,
            });
            reject(error);
          }
        );
      }
    ).then(
      all => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(all);
        }
      },
      error => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const assembleiasAssociadoActionsLoadDemaisAssembleias = (
  callbackSuccess?: (all: IAssembleiaAssociado[]) => void,
  callbackError?: (error: AxiosError<ErrorAPI>) => void
) => {
  return (dispatch: Dispatch<AssembleiasAssociadoActionTypes>) => {
    dispatch({
      type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_DEMAIS_ASSEMBLEIAS,
      payload: true,
    });
    new Promise(
      (
        resolve: (all: IAssembleiaAssociado[]) => void,
        reject: (error: AxiosError<ErrorAPI>) => void
      ) => {
        toRequest(
          ApiService.get,
          [`${getAssembleiasAssociadoEventoEndpoint()}assembleia/dia`],
          'assembleiasAssociadoActionsLoadAll'
        ).then(
          resp => {
            const data: IAssembleiaAssociado[] = resp.data as IAssembleiaAssociado[];
            dispatch({
              type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_DEMAIS_ASSEMBLEIAS,
              payload: data,
            });
            dispatch({
              type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_DEMAIS_ASSEMBLEIAS,
              payload: false,
            });
            resolve(data);
          },
          (error: AxiosError<ErrorAPI>) => {
            dispatch({
              type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_DEMAIS_ASSEMBLEIAS,
              payload: false,
            });
            reject(error);
          }
        );
      }
    ).then(
      all => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(all);
        }
      },
      error => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export function assembleiasAssociadoActionsDeleteCurrentEvent(): IAssembleiaAssociadoDeleteCurrentEvent {
  return {
    type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_DELETE_CURRENT_EVENT,
    payload: undefined,
  };
}

type ThunkLoadEventReturn = ThunkAction<
  Promise<void>,
  IReducer,
  undefined,
  Action
>;

export function assembleiaAssociadoActionsLoadEvent(
  idEvent: number,
  successCallback?: (evento: AssembleiaResponse) => void,
  errorCallback?: (error: ErrorAPI) => void
): ThunkLoadEventReturn {
  return async dispatch => {
    dispatch({
      type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_EVENT,
      payload: true,
    });
    const { fail, data } = await eventoAPI.carregar(idEvent);
    const newDataAny: any = { ...data };
    if (fail) {
      errorCallback && errorCallback(fail);
    }
    const newData = {
      ...newDataAny,
      id: newDataAny.idAssembleia
    }
    if (newData) {
      dispatch({
        type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_EVENT,
        payload: newData,
      });
      successCallback && successCallback(newData);
    }
    dispatch({
      type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_EVENT,
      payload: false,
    });
  };
}

export type ThunkDownloadDocumentReturn = ThunkAction<
  Promise<void>,
  IReducer,
  undefined,
  Action
>;

export function assembleiaAssociadoActionsDownloadDocument(
  idDocument: number,
  fileName: string,
  successCallback?: () => void,
  errorCallback?: (error: ErrorAPI) => void
): ThunkDownloadDocumentReturn {
  return async (dispatch, getState) => {
    dispatch({
      type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_REQUEST_FILE,
      payload: [...getState().assembleias.downloadindDocument, idDocument],
    });
    const { fail, data: file } = await documentosAPI.download(idDocument);
    if (fail) {
      errorCallback && errorCallback(fail);
    }
    if (file) {
      trigger(fileName, file);
      dispatch({
        type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_DOWNLOAD_FILE_SUCCESS,
        payload: [...getState().assembleias.downloadSuccessfully, idDocument],
      });
      successCallback && successCallback();
    }
    dispatch({
      type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_REQUEST_FILE,
      payload: getState().assembleias.downloadindDocument.filter(
        id => id !== idDocument
      ),
    });
  };
}

export type ThunkLoadDuvidasReturn = ThunkAction<
  Promise<void>,
  IReducer,
  undefined,
  Action
>;

let duvidasLoading: {
  idEvento: number,
  usuario: string,
  loading: boolean
}[] = [];

const getDuvidasLoadingIndex = (idEvento: number): number => {
  return duvidasLoading.map((duvida): number => {
    return duvida.idEvento
  }).indexOf(idEvento);
}

const duvidasIsLoading = (idEvento: number, usuario: string): boolean => {
  const foundIndex = getDuvidasLoadingIndex(idEvento);
  const found = foundIndex > -1 ? duvidasLoading[foundIndex] : null;
  if (found) {
    return found.idEvento === idEvento && found.usuario === usuario && found.loading;
  }
  return false;
}

const setDuvidasLoading = (idEvento: number, usuario: string, loading: boolean = true) => {
  const foundIndex = getDuvidasLoadingIndex(idEvento);
  if (foundIndex > -1) {
    duvidasLoading[foundIndex] = {
      ...duvidasLoading[foundIndex],
      loading
    };
  } else {
    duvidasLoading.push({
      idEvento,
      usuario,
      loading
    })
  }
}

export const assembleiaAssociadoActionsLoadDuvidas = (
  idEvento: number,
  usuario: string,
  successCallback?: () => void,
  errorCallback?: (error: ErrorAPI) => void,
): ThunkLoadDuvidasReturn => {
  return async dispatch => {
    if (duvidasIsLoading(idEvento, usuario)) {
      return;
    }
    setDuvidasLoading(idEvento, usuario, true);
    dispatch({
      type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_DUVIDAS,
      payload: true,
    });
    const { fail, data } = await duvidasAPI.listar(idEvento);
    if (fail) {
      errorCallback && errorCallback(fail);
    }
    if (data) {
      const publica = data.filter(pergunta => pergunta.cpfUsuario !== usuario);
      const privado = data.filter(pergunta => pergunta.cpfUsuario === usuario);
      dispatch({
        type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_DUVIDAS,
        payload: {
          usuario: privado,
          publica
        }
      });
      successCallback && successCallback();
    }
    dispatch({
      type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_DUVIDAS,
      payload: false,
    });
    setDuvidasLoading(idEvento, usuario, false);
  };
};

export const assembleiasAssociadoActionsLoadByCpfCnjp = (
  cpfCnpj: string,
  callbackSuccess?: (all: AssembleiasConvocado) => void,
  callbackError?: (error: ErrorAPI) => void
) => {
  return async (dispatch: Dispatch<AssembleiasAssociadoActionTypes>) => {
    dispatch({
      type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_BY_CPF_CNPJ,
      payload: true,
    });
    const { fail, data } = await convocadoAPI.assembleias(cpfCnpj);
    if (fail) {
      callbackError && callbackError(fail);
    }
    if (data) {
      dispatch({
        type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_BY_CPF_CNPJ,
        payload: data,
      });
      callbackSuccess && callbackSuccess(data);
    }
    dispatch({
      type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_BY_CPF_CNPJ,
      payload: false,
    });
  };
};

export const assembleiasAssociadoActionsLoadRespostaPauta = (
  idPauta: number,
  callbackSuccess?: (all: IAssembleiaAssociadoRespostaPauta) => void,
  callbackError?: (error: AxiosError<ErrorAPI>) => void
) => {
  return (dispatch: Dispatch<AssembleiasAssociadoActionTypes>) => {
    dispatch({
      type: ASSEMBLEIAS_ASSOCIADO_LOADING_RESPOSTA_PAUTA,
      payload: true,
    });
    new Promise(
      (
        resolve: (all: IAssembleiaAssociadoRespostaPauta) => void,
        reject: (error: AxiosError<ErrorAPI>) => void
      ) => {
        toRequest(
          ApiService.get,
          [
            `${getAssembleiasAssociadoEndpoint()}resposta-pauta/${ idPauta }/por-agencia`,
          ],
          'assembleiasAssociadoActionsLoadRespostaPauta'
        ).then(
          resp => {
            const data: IAssembleiaAssociadoRespostaPauta = resp.data as IAssembleiaAssociadoRespostaPauta;
            dispatch({
              type: ASSEMBLEIAS_ASSOCIADO_LOAD_RESPOSTA_PAUTA,
              payload: data,
            });
            dispatch({
              type: ASSEMBLEIAS_ASSOCIADO_LOADING_RESPOSTA_PAUTA,
              payload: false,
            });
            resolve(data);
          },
          (error: AxiosError<ErrorAPI>) => {
            dispatch({
              type: ASSEMBLEIAS_ASSOCIADO_LOADING_RESPOSTA_PAUTA,
              payload: false,
            });
            reject(error);
          }
        );
      }
    ).then(
      all => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(all);
        }
      },
      error => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const assembleiasAssociadoListDocumentos = ( 
  idAssembleia:number,
  callbackSuccess?: (documentos: DocumentoResponse[]) => void,
  callbackError?: (error: AxiosError<ErrorAPI>) => void) => {
  return (dispatch: Dispatch<AssembleiasAssociadoActionTypes>) => {
    dispatch({
      type: ASSEMBLEIAS_ASSOCIADO_LOADING_DOCUMENTOS,
      payload: true
    });
    new Promise((resolve: (documentos: DocumentoResponse[]) => void, reject: (error: AxiosError<ErrorAPI>) => void) => {
      toRequest(
        ApiService.get,
        [`${getAssembleiasAssociadoEndpoint(1)}documento/assembleia/${idAssembleia}`],
        'encerrar')
        .then(
          (resp: AxiosResponse) => {
            const documentos: DocumentoResponse[] = resp.data as DocumentoResponse[];
            dispatch({
              type: ASSEMBLEIAS_ASSOCIADO_LOAD_DOCUMENTOS,
              payload: documentos
            });
            dispatch({
              type: ASSEMBLEIAS_ASSOCIADO_LOADING_DOCUMENTOS,
              payload: false
            });
            resolve(documentos);
          },
          (error: AxiosError<ErrorAPI>) => {
            dispatch({
              type: ASSEMBLEIAS_ASSOCIADO_LOADING_DOCUMENTOS,
              payload: false
            });
            reject(error);
          }
        )
    }).then(
      (documentos: DocumentoResponse[]) => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(documentos);
        }
      },
      error => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    )
  }
}

export const documentoActionDownload = (
  codigo: string,
  callbackSuccess?: (arrayBuffer: ArrayBuffer) => void,
  callbackError?: (error: AxiosError) => void,
) => {
  return () => {
    documentoServiceDownload(codigo).then(
      (arrayBuffer: ArrayBuffer) => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(arrayBuffer);
        }
      },
      (error: AxiosError) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      },
    );
  };
};